import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { BaseRenderTexture } from './BaseRenderTexture.mjs';
import { Texture } from '../textures/Texture.mjs';
var RenderTexture = /*#__PURE__*/function (_Texture) {
  _inherits(RenderTexture, _Texture);
  var _super = _createSuper(RenderTexture);
  function RenderTexture(baseRenderTexture, frame) {
    var _this;
    _classCallCheck(this, RenderTexture);
    _this = _super.call(this, baseRenderTexture, frame);
    _this.valid = true;
    _this.filterFrame = null;
    _this.filterPoolKey = null;
    _this.updateUvs();
    return _this;
  }
  _createClass(RenderTexture, [{
    key: "framebuffer",
    get: function get() {
      return this.baseTexture.framebuffer;
    }
  }, {
    key: "multisample",
    get: function get() {
      return this.framebuffer.multisample;
    },
    set: function set(value) {
      this.framebuffer.multisample = value;
    }
  }, {
    key: "resize",
    value: function resize(desiredWidth, desiredHeight) {
      var resizeBaseTexture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var resolution = this.baseTexture.resolution;
      var width = Math.round(desiredWidth * resolution) / resolution;
      var height = Math.round(desiredHeight * resolution) / resolution;
      this.valid = width > 0 && height > 0;
      this._frame.width = this.orig.width = width;
      this._frame.height = this.orig.height = height;
      if (resizeBaseTexture) {
        this.baseTexture.resize(width, height);
      }
      this.updateUvs();
    }
  }, {
    key: "setResolution",
    value: function setResolution(resolution) {
      var baseTexture = this.baseTexture;
      if (baseTexture.resolution === resolution) {
        return;
      }
      baseTexture.setResolution(resolution);
      this.resize(baseTexture.width, baseTexture.height, false);
    }
  }], [{
    key: "create",
    value: function create(options) {
      return new RenderTexture(new BaseRenderTexture(options));
    }
  }]);
  return RenderTexture;
}(Texture);
export { RenderTexture };